<button class="language-selector" [matMenuTriggerFor]="languageMenu" mat-button>
  <mat-icon class="language-selector__icon">language</mat-icon>
  <span class="language-selector__label">{{ getSelectedLanguageName() }}</span>
</button>

<mat-menu #languageMenu="matMenu" class="language-selector__menu">
  <button
    mat-menu-item
    *ngFor="let language of languages"
    (click)="onLanguageChange(language.code)"
    [class.language-selector__menu-item--active]="language.code === selectedLanguage"
  >
    {{ language.nativeName }}
  </button>
</mat-menu>

